export { default as Logos } from './Logos';